import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";

// components
import AppRequestLogForm from "./_form";
import AppRequestLogList from "./_list";
import {showLoader} from "../../../components/loader/loader";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// actions
import { clearState, setApp, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { clearState as clearListState } from "../../../redux/actions/generalActions/listActions";
import { setForm } from "../../../redux/actions/generalActions/formActions";
import {getStateByPath} from "../../../redux/selectors";
import PlaceList from "../../core/place/_list";
import {ADD_STATE, REMOVE_STATE} from "../../../redux/actions/generics/IndexedActions";

function AppRequestLog(props) {
    //const { loading } = props.mainProps

    const path = props.path || 'monitor/appRequestLog';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    // useEffect(() => {
    //     return () => {
    //         props.clearState();
    //         props.clearListState();
    //     }
    // }, []);

    const createItem = () => {
        props.setForm();
        ModalFormContainer( AppRequestLogForm, {  } )
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    { componentState && <AppRequestLogList path={path}/> }
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = state => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
});

export default connect(mapStateToProps, mapActionsToProps)(AppRequestLog)

